export default "__VITE_ASSET__BZP74t45__"